import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsNumber,
  IsString,
  IsUUID,
  MaxLength,
  MinLength,
} from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { MaterialInterface } from '../interfaces/material.interface';

import { BoardPurchaseDto } from '../../board-purchase/dto/board-purchase.dto';

@Exclude()
export class MaterialDto extends CommonEntityDto implements MaterialInterface {
  @ApiProperty({
    title: 'Name',
    description: 'The name of the Material',
    minLength: 2,
    maxLength: 100,
  })
  @IsString()
  @MinLength(2)
  @MaxLength(100)
  @Expose()
  name!: string;

  @ApiProperty({
    title: 'Description',
    description: 'The description of the Material',
    minLength: 1,
    maxLength: 500,
  })
  @IsString()
  @MinLength(1)
  @MaxLength(500)
  @Expose()
  description!: string;

  @ApiProperty({
    title: 'Unit',
    description: 'The unit of measure for the Material',
    minLength: 1,
    maxLength: 50,
  })
  @IsString()
  @MinLength(1)
  @MaxLength(50)
  @Expose()
  unit!: string;

  @ApiProperty({
    title: 'Amount',
    description: 'The number of units of material.',
    minimum: 0,
  })
  @IsNumber()
  @Expose()
  amount!: number;

  @ApiProperty({
    format: 'uuid',
    title: 'Board Purchase ID',
    description: 'The ID of the board purchase this material belongs to',
  })
  @IsUUID()
  @Expose()
  boardPurchaseId!: string;

  @ApiPropertyOptional({
    type: () => BoardPurchaseDto,
    title: 'Associated Board Purchase',
    description: 'The board purchase this material belongs to',
  })
  @Expose()
  boardPurchase?: BoardPurchaseDto;
}
